// src/pages/About.js
import React, { useState } from "react";
import "./About.css";
import AboutPopUp from "../AboutPopUp";

function About() {
  const [popupData, setPopupData] = useState(null);

  const processData = [
    {
      id: 1,
      title: "Car Accidents",
      content:
        "If you were injured in a crash, we help you pursue compensation for medical bills, lost income, and pain and suffering. We handle communications with the insurance company, gather key documentation, and build a clear claim strategy so you can focus on recovery.",
      videoIndex: 1,
    },
    {
      id: 2,
      title: "Motorcycle Accidents",
      content:
        "Motorcycle injuries are often serious and riders can face unfair blame. We work to preserve evidence, document injuries, and present the facts clearly—pursuing the coverage available and advocating for a fair outcome.",
      videoIndex: 2,
    },
    {
      id: 3,
      title: "Truck Accidents",
      content:
        "Truck accident cases often involve severe injuries, multiple parties, and commercial insurance issues. We work to preserve evidence, investigate the facts, identify responsible parties, and pursue the compensation you may be entitled to recover.",
      videoIndex: 3,
    },
    {
      id: 4,
      title: "Dog Bites",
      content:
        "Dog bite injuries can leave lasting physical and emotional harm. We help clients document the incident, protect their rights, and pursue recovery for medical treatment, scarring, trauma, and other damages.",
      videoIndex: 4,
    },
    {
      id: 5,
      title: "Slip & Falls",
      content:
        "Property owners have a duty to keep premises reasonably safe. If dangerous conditions caused your fall, we investigate quickly, preserve evidence, and work to connect the hazard to your injuries and damages.",
      videoIndex: 5,
    },
    {
      id: 6,
      title: "Rideshare (Uber / Lyft)",
      content:
        "Rideshare claims can involve multiple insurance policies and parties. Whether you were a passenger, driver, or struck by a rideshare vehicle, we help identify coverage, clarify responsibility, and pursue the right parties.",
      videoIndex: 6,
    },
    {
      id: 7,
      title: "Pedestrian Accidents",
      content:
        "Pedestrians are especially vulnerable in traffic collisions. If you or a loved one was hit by a vehicle, we help build a strong claim supported by treatment records, evidence, and clear advocacy.",
      videoIndex: 7,
    },
    {
      id: 8,
      title: "Civil Rights",
      content:
        "Civil rights cases can involve serious misconduct, abuse of power, or violations of constitutional protections. We help clients build strong claims supported by evidence, documentation, and focused advocacy.",
      videoIndex: 8,
    },
  ];

  const openPopup = (item) => setPopupData(item);
  const closePopup = () => setPopupData(null);

  return (
    <div className="about-page">
      <div className="about-container">
        <h1>About the Attorney</h1>
        <p>
          <strong>Edgar Lopez Law</strong> is founded by Edgar Lopez, a
          distinguished graduate of California Western School of Law in San
          Diego, California. He built his practice with a clear mission: to
          advocate fiercely for people who need a strong and dedicated voice on
          their side.
        </p>
        <p>
          Although his legal career began in defense, it quickly became clear
          that his true calling was representing injured individuals and helping
          them pursue justice. That realization led him to establish a practice
          focused exclusively on Personal Injury Law.
        </p>
        <p>
          Serving the Inland community and surrounding areas, Edgar Lopez is
          committed to helping clients seek the best possible outcome in a wide
          range of injury matters, including car accidents, motorcycle
          accidents, truck accidents, dog bites, slip and falls, pedestrian
          accidents, rideshare accidents, and civil rights matters.
        </p>

        <h2>Our Practice Focus</h2>
        <p>
          Our practice focuses on a select set of injury and related civil
          matters. Tap any practice area below to learn more about what these
          cases involve and how we approach them.
        </p>
        <ul className="process-list">
          {processData.map((item) => (
            <li key={item.id} onClick={() => openPopup(item)}>
              <strong>{item.title}:</strong> {item.content.substring(0, 80)}...
            </li>
          ))}
        </ul>

        <h2>Our Commitment</h2>
        <p>
          When you choose Edgar Lopez Law, you gain a dedicated advocate who
          works relentlessly to pursue the compensation you may be owed. We
          believe clients deserve straightforward guidance, strong communication,
          and focused advocacy from beginning to end. <strong>El abogado Edgar
          Lopez habla español con fluidez.</strong>
        </p>
      </div>

      {popupData && (
        <AboutPopUp
          onClose={closePopup}
          title={popupData.title}
          content={popupData.content}
          videoIndex={popupData.videoIndex}
        />
      )}
    </div>
  );
}

export default About;